import { type AppState } from '../store/appStore';

export const getPaneIsOpenFromSessionStorage = () => {
    try {
        const paneIsOpenString = sessionStorage.getItem('paneIsOpen');

        if (!paneIsOpenString) {
            return undefined;
        }

        return JSON.parse(paneIsOpenString) as AppState['paneIsOpen'];
    } catch (err) {
        return undefined;
    }
};

export const savePaneIsOpenToSessionStorage = (paneIsOpen: AppState['paneIsOpen']) => {
    sessionStorage.setItem('paneIsOpen', JSON.stringify(paneIsOpen));
};
